
  import vipSettings from '~/mixins/pages/mission-control/vipSettings'
  export default {
    name: 'Theme2DesktopProfilesMyProfile',
    mixins: [vipSettings],
    data() {
      return {
        tab: 0
      }
    }
  }
